export const SET_HOME_PAGE_DATA = 'SET_HOME_PAGE_DATA';
